(function() {
    'use strict';

    //Bootstrap the application AFTER loading translation files
    angular.element(document).ready(()=>{
        window.deferredBootstrapper.bootstrap({
            element: document,
            module: 'icmWebApp',
            injectorModules: ['MW.Influencers.TranslationBootstrapService', 'MW.Configuration','MW.influencers.AuthTokenService'],
            resolve: {
                // IS_USER_LOGGED_IN: ['$q', 'AuthTokenService', '$window','LOGOUT_URL', function ($q, AuthTokenService, $window, LOGOUT_URL) {
                //     if (AuthTokenService.isTokenExpired()) {
                //         $window.location.href = LOGOUT_URL;
                //     }
                //
                //     return $q.when(true);
                // }],
                TRANSLATION_CONFIG: ['TranslationBootstrapService', 'ICM_ASSETS_URL', function(TranslationBootstrapService, ICM_ASSETS_URL){
                    return TranslationBootstrapService.getUserTranslationData(ICM_ASSETS_URL);
                }]
            }
        });
    });

    angular.
    module('icmWebApp')
        .config([
            '$locationProvider',
            '$routeProvider',
            '$httpProvider',
            'tagsInputConfigProvider',
            'ICM_ASSETS_URL',
            'NEWSWIRE_WEB_URL',
            'ATATUS_KEY',
            'ENABLE_ATATUS',
            'IRM_BASE_URL',
            function config($locationProvider, $routeProvider, $httpProvider, tagsInputConfigProvider, ICM_ASSETS_URL, NEWSWIRE_WEB_URL, ATATUS_KEY, ENABLE_ATATUS, IRM_BASE_URL) {
                $locationProvider.html5Mode(true);
                $.ajaxSetup({cache: true});

                if((ENABLE_ATATUS === true) && window.atatus) {
                    window.atatus.config(ATATUS_KEY).install();
                }

                // moment was defaulting to zh-tw without this. unkown why.
                if(window.moment) {
                    window.moment.locale('en');
                }

                function handleICMContactRedirect(ManifestService, url) {
                    return new Promise((resolve)=>{
                        ManifestService.getManifest().then((res)=>{
                            const migrationSplit = res.featureToggles.company.treatments.CONTACTS_TO_MEDIA_LISTS_MIGRATION;
                            if(migrationSplit === 'off') {
                                window.location.href = url;
                            }
                            resolve(true);
                        }).catch(() =>{
                            resolve(true);
                        });
                    });
                }

                $routeProvider
                    .when('/outreach/compose/:distributionId?/:state?', {
                        templateUrl: 'icm-web/views/outreach_compose',
                        controller: 'ContactManagerOutreachComposeController',
                        controllerAs: 'outreachComposeController',
                        isChromeless: true,
                        resolve: {
                            setRecipientFromQueryString: function($route, InfluencerContactService, ICMEmailService) {
                                let contactId = null;
                                let selectedEmail = null;
                                if ($route && $route.current && $route.current.params) {
                                    if ($route.current.params.recipient) {
                                        contactId = $route.current.params.recipient.split(' ');
                                    } else if ($route.current.params.local) {
                                        contactId = JSON.parse(localStorage.getItem('contactIds')) || '';
                                        localStorage.removeItem('contactIds');
                                    }
                                    if ($route.current.params.email) {
                                        selectedEmail = $route.current.params.email;
                                    }
                                }
                                if(contactId) {
                                    return InfluencerContactService.getContactsById(contactId)
                                    .then((contact) => {
                                            if(selectedEmail) {
                                                // verify the email from the url belongs to the contact
                                                const contactSelectedEmail = contact[0].contactInfo.email.find(email => email.address === selectedEmail);
                                                if(contactSelectedEmail) {
                                                    contact[0].contactInfo.email = [contactSelectedEmail];
                                                }
                                            }
                                            return ICMEmailService.setContactRecipients(contact);
                                        })
                                        .finally(() => {
                                            return;
                                        });
                                } else {
                                    return;
                                }
                            },
                            editorLanguage: function(CoreUserService) {
                                return CoreUserService.getCurrent(true).then(function (currentUser) {
                                    return currentUser.language;
                                }).catch(function () {
                                    return 'en';
                                });
                            },
                            approvedSenderArray: function getApprovedSender(ICMEmailService) {
                                return ICMEmailService.getIcmApprovedSenders().then(function afterGetApprovedSender(approvedSenderArray) {
                                    return approvedSenderArray || [];
                                }).catch(function () {
                                    return 'error';
                                });
                            },
                            sendgridDomainsArray: function getSendgridDomains(SendgridService) {
                                return SendgridService.getCompanyDomains()
                                    .then(function (domains) {
                                        return domains;
                                    }).catch(function () {
                                        return [];
                                    });
                            },
                            templatesList: function getTemplates(EmailTemplateService) {
                                return EmailTemplateService.getAllTemplates().then(function(response){
                                    if (response && response.data && response.data.templates) {
                                        return response.data.templates.map(function(template) {
                                            return {
                                                id: template.id,
                                                title: template.name,
                                                body: template.body
                                            };
                                        });
                                    }
                                    else {
                                        return [];
                                    }
                                })
                                .catch(function() {
                                    return [];
                                });
                            },
                            dialogMode: function dialogMode($q) {
                                return $q.when(false);
                            },
                            loadEditorLibrary: function loadEditorLibrary(ICM_ASSETS_URL) {
                                angular.element('.tinymceLib').remove();
                                var tiny5 = document.createElement('script');
                                tiny5.setAttribute('class', 'tinymceLib');
                                tiny5.setAttribute('src', ICM_ASSETS_URL +'client/js/lib/tinymce_v5/tinymce_v5.min.js');
                                document.head.appendChild(tiny5);
                                return true;
                            },
                            identity: function(ICMUserService) {
                                return ICMUserService.getIdentity(false);
                            }
                        },
                        reloadOnSearch: false
                    })
                    .when('/influencers/lists', {
                        templateUrl: 'icm-web/views/media_list',
                        activeTab: 'contact_manager',
                        controller: 'MediaListController',
                        controllerAs: 'listController',
                        hideFooter: true,
                        reloadOnSearch: false,
                        useActionBar: true,
                        resolve: {
                            checkMediaListMigrationSplit: function checkMediaListMigrationSplit(ManifestService){
                                return handleICMContactRedirect(ManifestService, `${window.location.origin}/a/media-relations/media-lists`);
                            },
                            emptyStateVisible: function(ContactManagerTagService){
                                return new Promise((resolve)=>{
                                    ContactManagerTagService.getAllTags(1, 1).then((res)=>{
                                        resolve(res.count <= 0);
                                    })
                                        .catch(() =>{
                                            resolve(true);
                                        });
                                });
                            }
                        }
                    })
                    .when('/influencers/contact-list/:listId?', {
                        templateUrl: 'icm-web/views/contact_list_v2',
                        activeTab: 'contact_manager',
                        controller: 'ListViewController',
                        controllerAs: 'listController',
                        hideFooter: true,
                        reloadOnSearch: false,
                        useActionBar: true,
                        resolve: {
                            checkMediaListMigrationSplit: function checkMediaListMigrationSplit(ManifestService, $route){
                                const baseUrl = `${window.location.origin}/a/media-relations/media-lists`;
                                const redirectUrl = $route.current.params.listId ? `${baseUrl}/${$route.current.params.listId}` : baseUrl;
                                return handleICMContactRedirect(ManifestService, redirectUrl);
                            }
                        }
                    })
                    .when('/influencers/contact/landing', {
                        templateUrl: 'icm-web/views/contact_landing',
                        activeTab: 'contact_manager',
                        controller: 'ContactLandingController',
                        controllerAs: 'landingController',
                        hideFooter: true,
                        useActionBar: true,
                        resolve: {
                            isInfluencerDatabaseEntitled: function getEntitlement(EntitlementService) {
                                return EntitlementService.getIcmCountriesEntitlement().then(function afterGetIcmCountriesEntitlement(countriesList) {
                                    return (countriesList && countriesList.length > 0) ? true : false;
                                });
                            }
                        }
                    })
                    .when('/influencers/contact/create', {
                        templateUrl: 'icm-web/views/contact_form',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerFormController',
                        controllerAs: 'formController',
                        hideFooter: true,
                        resolve: {
                            redirectTo: function() {
                                window.location.href = `${window.location.origin}/a/media-relations/contacts/create`;
                            },
                            breadcrumbs: function(Breadcrumb) {
                                return Breadcrumb.build([
                                    {name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists'},
                                    {name: 'Add Contacts', link: '/influencers/contact/landing'},
                                    {name: 'Create New Contact', link: '/influencers/contact/create'}
                                ]);
                            },
                            contact: function(Contact) {
                                return new Contact();
                            }
                        }
                    })
                    .when('/influencers/contact/edit/:contactId', {
                        templateUrl: 'icm-web/views/contact_form',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerFormController',
                        controllerAs: 'formController',
                        hideFooter: true,
                        resolve: {
                            breadcrumbs: function(Breadcrumb, $route) {
                                var contactId = $route.current.params.contactId;

                                return Breadcrumb.build([
                                    {name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists'},
                                    {name: 'Edit Contact', link: '/influencers/contact/edit/' + contactId}
                                ]);
                            },
                            contact: function($q, InfluencerContactService, $route) {
                                var defer = $q.defer(),
                                    contactId = $route.current.params.contactId;

                                InfluencerContactService.getCurrentContact(contactId).then(function(contact) {
                                    defer.resolve(contact);
                                });

                                return defer.promise;
                            }
                        }
                    })
                    .when('/influencers/contact/view/:contactId', {
                        templateUrl: 'icm-web/views/search_loading',
                        activeTab: 'contact_manager',
                        controller: 'ProfileSwitcherController',
                        hideFooter: true
                    })
                    .when('/influencers/contact/v1/:contactId', {
                        templateUrl: 'icm-web/views/search_loading',
                        activeTab: 'contact_manager',
                        controller: 'ProfileSwitcherController',
                        hideFooter: true
                    })
                    .when('/influencers/contact/showmore/:contactId/:typeVal', {
                        templateUrl: 'icm-web/views/partials/contact_historytable_fullview',
                        activeTab: 'contact_manager',
                        controller: 'ContactHistoryTableController',
                        controllerAs: 'historyTableController',
                        hideFooter: true,
                        resolve: {
                            breadcrumbs: function(Breadcrumb, $route) {
                                var contactId = $route.current.params.contactId;
                                return Breadcrumb.build([
                                    {name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists'},
                                    {name: 'Profile', link: '/influencers/contact/view/' + contactId},
                                    {name: 'Contact History'}
                                ]);
                            }
                        }
                    })
                    .when('/influencers/contact/import', {
                        templateUrl: 'icm-web/views/contact_import',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerImportController',
                        controllerAs: 'importController',
                        hideFooter: true,
                        resolve: {
                            breadcrumbs: function(Breadcrumb) {
                                return Breadcrumb.build([
                                    {name: 'icm-breadcrumbs--my-contacts', link: '/influencers/lists'},
                                    {name: 'Add Contacts', link: '/influencers/contact/landing'},
                                    {name: 'Import Contacts', link: '/influencers/contact/import'}
                                ]);
                            },
                            companyId: function(CoreCompanyService) {
                                return CoreCompanyService.getCurrent(true).then(function(response) {
                                    return response._id;
                                });
                            },
                            readyTranslations: function($translate) {
                                return $translate.onReady();
                            }
                        }
                    })
                    .when('/influencers/source/view/:sourceId', {
                        templateUrl: 'icm-web/views/search_loading',
                        activeTab: 'contact_manager',
                        controller: 'SourceSwitcherController',
                        hideFooter: true
                    })
                    .when('/influencers/contact/influencerdatabase', {
                        templateUrl: 'icm-web/views/influencer_database_upsell',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerInfluencerDatabaseUpsellController',
                        controllerAs: 'influencerDatabaseUpsellController',
                        hideFooter: true,
                        resolve: {
                            isInfluencerAppEntitled: function getEntitlement(EntitlementService) {
                                return EntitlementService.getInfluencerAppEntitlement().then(function getEntitlement(entitlement) {
                                    return (!!entitlement);
                                });
                            }
                        }
                    })
                    .when('/influencers/contact/outreach', {
                        templateUrl: 'icm-web/views/outreach_list',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerOutreachListController',
                        controllerAs: 'outreachListController',
                        useActionBar: true,
                        hideFooter: true,
                        useMaterial: true,
                        reloadOnSearch: false,
                        resolve: {
                            breadcrumbs: function(Breadcrumb) {
                                return Breadcrumb.build([{name: 'Outreach', link: '/influencers/contact/outreach/'}]);
                            },
                            translationsReady: function($timeout, $q, translationService) {
                                var translationDeferred = $q.defer();
                                var timeoutPromise = $timeout(function() {
                                    translationDeferred.resolve();
                                }, 500);

                                translationService.waitForTranslations().then(function() {
                                    $timeout.cancel(timeoutPromise);
                                    translationDeferred.resolve();
                                });
                                return translationDeferred.promise;
                            },
                            identity: function(ICMUserService) {
                                return ICMUserService.getIdentity(false);
                            }
                        }
                    })
                    .when('/email_layout/icm_enquiry', {
                        templateUrl: 'icm-web/views/html_icm_enquiry_email_view',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerIcmEnquiryController',
                        controllerAs: 'icmEnquiryController',
                        reloadOnSearch: false,
                        hideNavigation: true,
                        hideSubTabs: true
                    })
                    .when('/influencers/contact/outreach/:sentEmailDistributionId', {
                        templateUrl: 'icm-web/views/outreach_stats',
                        activeTab: 'contact_manager',
                        controller: 'ContactManagerOutreachViewController',
                        controllerAs: 'outreachViewController',
                        isChromeless: true,
                        reloadOnSearch: false,
                        hideSubTabs: true,
                        resolve: {
                            emailId: function($route) {
                                return $route.current.params.sentEmailDistributionId;
                            },
                            readyTranslations: function(translationService) {
                                return translationService.waitForTranslations();
                            },
                            approvedSenders: function(ICMEmailService){
                                return ICMEmailService.getIcmApprovedSenders();
                            }
                        }
                    })
                    .when('/newswire/organizationApprove/:companyId/:uniqueKey/:organizationId', {
                        activeTab: 'contact_manager',
                        reloadOnSearch: false,
                        resolve: {}
                    })
                    .when('/newswire/landing/:distributionId?/:action?/:createDistributionModal?/:step?', {
                        activeTab: 'contact_manager',
                        useActionBar: true,
                        reloadOnSearch: false,
                        resolve: {
                            function() {
                                window.location.replace(NEWSWIRE_WEB_URL + '/newswire/landing');
                            },
                        }
                    })
                    .when('/influencers/search', {
                        templateUrl: 'icm-web/views/search_loading',
                        activeTab: 'contact_manager',
                        controller: 'SearchSwitcherController',
                        hideFooter: true
                    })
                    .when('/influencers/search/v1', {
                        templateUrl: 'icm-web/views/search_loading',
                        activeTab: 'contact_manager',
                        controller: 'SearchSwitcherController',
                        hideFooter: true
                    })
                    .when('/influencers/search/v2', {
                        templateUrl: 'icm-web/views/searchV2',
                        activeTab: 'contact_manager',
                        controller: 'SearchControllerV2',
                        controllerAs: 'searchController',
                        hideFooter: true,
                        reloadOnSearch: false,
                        customContainerClass: 'search',
                        resolve: {
                            readyTranslations: function($translate) {
                                return $translate.onReady();
                            },
                            countryMapping: function($http){
                                return $http.get(ICM_ASSETS_URL + 'js/countryMapping.json');
                            },
                            companyServiceResolved: function(CoreCompanyService) {
                                return CoreCompanyService.getCurrent(true);
                            },
                            userServiceResolved: function(CoreUserService) {
                                return CoreUserService.getCurrent(true);
                            },
                            allContactsCount: function(ContactManagerTagService) {
                                return ContactManagerTagService.getAllContacts({page: 0, pageSize: 1})
                                    .then((response) => {
                                        return response.count;
                                    })
                                    // we need to gracefully handle the error scenario, or this route will not load.
                                    .catch(() => {
                                        return -1;
                                    });
                            }
                        }
                    })
                    .otherwise({
                        redirectTo: function() {
                            window.location.href = IRM_BASE_URL;
                        }
                    });

                $httpProvider.interceptors.push('AuthTokenHttpInterceptor');

                // set our app's defaults for ngTagsInput, can be overriden inline when using the directive
                tagsInputConfigProvider
                    .setDefaults('tagsInput', {
                        removeTagSymbol: '',
                        customClass: 'keywordTags',
                        placeholder: '',
                        minLength: 2,
                        addOnEnter: true,
                        addOnSpace: false,
                        addOnComma: false,
                        addOnBlur: true,
                        allowedTagsPattern: new RegExp('.*'),
                        enableEditingLastTag: false,
                        replaceSpacesWithDashes: false,
                        immediatelyDeleteOnBackspace: true,
                        shouldStripChars: false
                    });
            }
        ])
        // register angular material themes
        .config(['$mdThemingProvider', function($mdThemingProvider) {
            $mdThemingProvider.theme('expansion-panel');
        }])
        .factory('$exceptionHandler', ['$log', '$window', 'ENABLE_ATATUS', function($log, $window, ENABLE_ATATUS) {
            return function customExceptionHandler(exception, cause) {
                if((ENABLE_ATATUS === true) && $window.atatus) {
                    $window.atatus.notify(exception);
                }

                // continue calling log.error, which will output to console
                $log.error(exception, cause);
            };
        }])
        .config(['$translateProvider', 'TRANSLATION_CONFIG', 'ICM_ASSETS_URL', function($translateProvider, TRANSLATION_CONFIG, ICM_ASSETS_URL){
            $translateProvider
                .translations(TRANSLATION_CONFIG.$locale, TRANSLATION_CONFIG.$translationList)
                .fallbackLanguage('en')
                .preferredLanguage(TRANSLATION_CONFIG.$locale)
                .useSanitizeValueStrategy('escape')
                .statefulFilter(false)
                .useStaticFilesLoader({
                    prefix: ICM_ASSETS_URL + 'translations/',
                    suffix: '.json?format=flat'
                });
        }])
        .config(['$mdIconProvider', function($mdIconProvider) {
            $mdIconProvider.iconSet('icm:influencer-lady', 'https://assets.meltwater.io/icm-web-assets/static/img/influencers.svg');
        }])
        .run([
            '$rootScope',
            'NotificationsService',
            'ICMUserService',
            'CoreUserService',
            'CoreCompanyService',
            'ContactManagerNavigationService',
            'EntitlementService',
            'ICM_WEB_PROXY_PREFIX',
            'PageStateService',
            '$location',
            'DialogService',
            '$translate',
            'AWS_ENV',
            'translationService',
            'TRANSLATION_CONFIG',
            'ActionBarService',
            'IdentityService',
            function($rootScope, NotificationsService, ICMUserService, CoreUserService, CoreCompanyService, ContactManagerNavigationService, EntitlementService, ICM_WEB_PROXY_PREFIX, PageStateService, $location, DialogService, $translate, AWS_ENV, translationService, TRANSLATION_CONFIG, ActionBarService) {
                let notificationPromises = [];
                let featureBranch = null;
                let isEntitled = true;

                notificationPromises.push(CoreUserService.getCurrent(true));
                notificationPromises.push(CoreCompanyService.getCurrent(true));

                Promise.all(notificationPromises).then((results) => {
                    NotificationsService.init({
                        user: results[0],
                        company: results[1]
                    });
                });

                $rootScope.$on('userUpdateFromNotificationRequired', function(event, args) {
                    ICMUserService.updateUser(args.userId, args.settings).then(() => {
                        if (args.requiresUserConfirmation) {
                            DialogService.flashSuccess($translate.instant('Settings saved successfully'));
                        }
                    }).catch(() => {
                        if (args.requiresUserConfirmation) {
                            DialogService.flashError($translate.instant('We were unable to update this user.'));
                        }
                    });
                });

                if(window.AppChrome && window.AppChrome.ready === true){
                    if(window.appContainerPlaceholder) {
                        window.appContainerPlaceholder.remove();
                    }
                } else {
                    window.addEventListener('app-chrome-ready', () => {
                        if(window.appContainerPlaceholder) {
                            window.appContainerPlaceholder.remove();
                        }
                    });
                }

                window.addEventListener('app-chrome-location-change-internal-app', (event) => {
                  // This event will fire any time navigation is triggered. It can be canceled to prevent that
                  // navigation. Note that you will be responsible for updating the navigation when you navigate. You can do that by
                  // calling window.AppChrome.updateActivePage() when navigation occurs.
                  event.preventDefault();
                  // We need to remove the base path defined in index, otherwise it tries to double up
                  let withoutBase = event.detail.location.replace('/icm-web/', '');

                  // We also need to look for any query params, it cannot be set on the path using $location, thanks angular
                  const qIndex = withoutBase.indexOf('?');
                  if( qIndex > -1) {
                    // There is a query parameter
                    // So remove it
                    withoutBase = withoutBase.slice(0, qIndex);

                    // Here, I don't bother adding the query parameter back on because it is
                    // automatically handled by some other bits of the router

                    // It is also important to note that when changing the path using `$location.path()`
                    // that the query parameter will not change. So the ?locker=blah will stick around
                    // unless we do a $location.search(''), to put it back to an empty string
                    // This is all because the angular $location is not the same as native location
                  }

                  $location.path(withoutBase);
                  $rootScope.$apply();
                });

                translationService.setLanguage(TRANSLATION_CONFIG.$locale);
                translationService.registerDictionary(TRANSLATION_CONFIG.$translationList);

                ContactManagerNavigationService.resetIcmLocationHistory();
                $rootScope.$on('$locationChangeSuccess', function(event, current, previous) {
                    // This triggers the header and navigation to update the active navigation item as you navigate through your app.
                    window.AppChrome.updateActivePage();
                    if(previous && current !== previous){
                        ContactManagerNavigationService.setPreviousLocation(previous, ICM_WEB_PROXY_PREFIX + (AWS_ENV ? '/awsEnv/' + AWS_ENV : ''));
                    }
                });

                EntitlementService.getInfluencerAppEntitlement().then(function(isICMAppEntitled) {
                    isEntitled = (isICMAppEntitled === true);
                    if (isICMAppEntitled !== true && $location.url().indexOf('/contact/influencerdatabase') === -1) {
                        $location.url('/influencers/contact/influencerdatabase');
                    }
                });

                $rootScope.$on('$routeChangeStart', function(event, next) {
                    if(next && next.$$route && next.$$route.templateUrl){
                        switch(next.$$route.templateUrl){
                            case 'icm-web/views/outreach_compose':
                            $('body').append(`<mw-loader id="loadingState" class="ng-isolate-scope">
                                                <div class="mw-loader">
                                                    <div class="mw-loader__drop"></div>
                                                    <div class="mw-loader__circle1"></div>
                                                    <div class="mw-loader__circle2"></div>
                                                </div>
                                            </mw-loader>`);
                            $('.OutreachListPage').remove();
                            $('.contactManagerApp').remove();
                        }
                    }
                });

                $rootScope.$on('$locationChangeStart', function (event, current) {
                    try{
                        const dialog = document.querySelector('icm-manage-lists-dialog');
                        const alertDialog = document.querySelector('manage-list-limit-warning');
                        const miniDialog = document.querySelector('icm-mini-profile-header').shadowRoot.querySelector('icm-manage-lists-dialog');

                        (dialog) ? dialog.close() :''; // jshint ignore:line
                        (alertDialog) ? alertDialog.close() :''; // jshint ignore:line
                        (miniDialog) ? miniDialog.close() :''; // jshint ignore:line
                    }catch(e){
                        console.error(e); // jshint ignore:line
                    }

                    if(window.tinymce && (current.indexOf('?createDistributionModal=true') === -1)) {
                        delete window.tinymce;
                        angular.element('.tinymceLib').remove();
                    }

                    if(featureBranch && !$location.search().branch) {
                        $location.search('branch', featureBranch);
                    }

                    if (!isEntitled) {
                        $location.url('/influencers/contact/influencerdatabase');
                    }
                });

                $rootScope.$on('$routeChangeError', function(evt, current, previous){
                    ActionBarService.resetState();
                    $('mw-loader').remove('#loadingState');

                    if(previous && previous.$$route && previous.$$route.originalPath){
                        $location.url(previous.$$route.originalPath);
                    } else {
                        $location.url('/');
                    }
                });

                $rootScope.$on('$routeChangeSuccess', function(event, current, previous) {
                    $('mw-loader').remove('#loadingState');
                    ActionBarService.resetState();

                    if(current.$$route && previous && previous.$$route && (current.$$route.originalPath.split('?')[0] !== previous.$$route.originalPath.split('?')[0]) && window.AppChrome){
                        window.AppChrome.scrollToContentTop();
                    }
                });

                if ($location.search() && $location.search().locker) {
                    PageStateService.setLockerId('contactListPage', $location.search().locker);
                }

                if ($location.search() && $location.search().branch) {
                    featureBranch = $location.search().branch;
                }
            }
        ]);
}());
